import { useEffect, useState } from "react";

// API endpoint. Defaults to same-origin `/api`. Override via .env if needed.
const API_BASE = process.env.REACT_APP_API_BASE || "/api";

const REFRESH_MS = 60_000; // 60 seconds
const API_KEY_STORAGE = "888g_admin_api_key";

// -------- Public (read-only) --------

export async function fetchAnnouncement() {
  try {
    const res = await fetch(`${API_BASE}/announcement.php`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch {
    return null;
  }
}

export function useAnnouncement() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const data = await fetchAnnouncement();
      if (!cancelled) setAnn(data);
    };
    load();
    const timer = setInterval(load, REFRESH_MS);
    const onUpdate = () => load();
    window.addEventListener("announcement-updated", onUpdate);
    return () => {
      cancelled = true;
      clearInterval(timer);
      window.removeEventListener("announcement-updated", onUpdate);
    };
  }, []);

  return ann;
}

// -------- Admin (write) --------

export function getStoredApiKey() {
  try {
    return (localStorage.getItem(API_KEY_STORAGE) || "").trim();
  } catch {
    return "";
  }
}

export function setStoredApiKey(key) {
  try {
    const trimmed = (key || "").trim();
    if (trimmed) localStorage.setItem(API_KEY_STORAGE, trimmed);
    else localStorage.removeItem(API_KEY_STORAGE);
  } catch {}
}

export async function saveAnnouncementApi(payload, apiKey) {
  const res = await fetch(`${API_BASE}/announcement.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Admin-Key": apiKey,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
  window.dispatchEvent(new Event("announcement-updated"));
  return data;
}

export async function uploadAnnouncementImage(file, apiKey) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API_BASE}/upload.php`, {
    method: "POST",
    headers: {
      "X-Admin-Key": apiKey,
    },
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
  return data;
}
